/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { personFragment } from '../../../apollo/fragments/personFragment.gql';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemovePersonFromRole_removePerson_CreditApplication_authorizedSigner_CreditApplicationPerson_address_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly city: string | null, readonly state: string | null, readonly street: string | null, readonly streetAdditional: string | null, readonly postalCode: string | null, readonly countryCode: string | null };

export type RemovePersonFromRole_removePerson_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: RemovePersonFromRole_removePerson_CreditApplication_authorizedSigner_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type RemovePersonFromRole_removePerson_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly title: string | null, readonly dob: any | null, readonly email: string | null, readonly passportCountry: string | null, readonly passportNumberLastFour: string | null, readonly passportExpiration: any | null, readonly passportNumberLength: number | null, readonly phoneNumber: string | null, readonly ssnLastFour: string | null, readonly verifiedPhoneNumber: string | null, readonly address: RemovePersonFromRole_removePerson_CreditApplication_authorizedSigner_CreditApplicationPerson_address_CreditApplicationAddress | null };

export type RemovePersonFromRole_removePerson_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type RemovePersonFromRole_removePerson_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly authorizedSigner: RemovePersonFromRole_removePerson_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly beneficialOwners: ReadonlyArray<RemovePersonFromRole_removePerson_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly savedSectionsInfo: ReadonlyArray<RemovePersonFromRole_removePerson_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type RemovePersonFromRole_Mutation = { readonly __typename: 'Mutation', readonly removePerson: RemovePersonFromRole_removePerson_CreditApplication };


export type RemovePersonFromRoleVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  personId: _Types.Scalars['ID']['input'];
  target: _Types.RemovePersonTarget;
}>;


export type RemovePersonFromRole = RemovePersonFromRole_Mutation;


export const RemovePersonFromRoleDocument = gql`
    mutation RemovePersonFromRole($creditApplicationId: ID!, $personId: ID!, $target: RemovePersonTarget!) {
  removePerson(
    creditApplicationId: $creditApplicationId
    personId: $personId
    removePersonTarget: $target
  ) {
    salesforceCreditId
    fetchedAt
    authorizedSigner {
      ...personFragment
    }
    beneficialOwners {
      ...personFragment
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${personFragment}
${CreditAppSavedSectionInfo}`;
export type RemovePersonFromRoleMutationFn = Apollo.MutationFunction<RemovePersonFromRole, RemovePersonFromRoleVariables>;

/**
 * __useRemovePersonFromRole__
 *
 * To run a mutation, you first call `useRemovePersonFromRole` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonFromRole` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonFromRole, { data, loading, error }] = useRemovePersonFromRole({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      personId: // value for 'personId'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useRemovePersonFromRole(baseOptions?: Apollo.MutationHookOptions<RemovePersonFromRole, RemovePersonFromRoleVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePersonFromRole, RemovePersonFromRoleVariables>(RemovePersonFromRoleDocument, options);
      }
export type RemovePersonFromRoleHookResult = ReturnType<typeof useRemovePersonFromRole>;
export type RemovePersonFromRoleMutationResult = Apollo.MutationResult<RemovePersonFromRole>;
export type RemovePersonFromRoleMutationOptions = Apollo.BaseMutationOptions<RemovePersonFromRole, RemovePersonFromRoleVariables>;